import {getPreference} from '@netx/core-user-next/utils/getPreference';
import {CartPref} from '../constants';

export const glacierArchiveEnabled = () =>
	getPreference(CartPref.GLACIER_ARCHIVE_ENABLED, true);

export default glacierArchiveEnabled;
